import React from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';

const TableSummary = ({ summaryItems = [] }) => {
  const { t } = useTranslation();

  if (!summaryItems || summaryItems.length === 0) {
    return null;
  }

  return (
    <Row className="">
      {summaryItems.map((item, index) => (
        <Col key={index} xl={3} md={6} sm={6}> 
          <Card className="card-animate overflow-hidden">
            <div
              className="position-absolute start-0"
              style={{ zIndex: "0" }}
            >
              <svg
                version="1.2"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 200 120"
                width="200"
                height="120"
              >
                <path
                  id={`shape-bg-${index}`} // Unique ID for SVG path
                  style={{ opacity: ".05", fill: "rgb(11 152 93)" }} // Example fill, can be dynamic
                  d="m189.5-25.8c0 0 20.1 46.2-26.7 71.4 0 0-60 15.4-62.3 65.3-2.2 49.8-50.6 59.3-57.8 61.5-7.2 2.3-60.8 0-60.8 0l-11.9-199.4z"
                />
              </svg>
            </div>
            <CardBody>
              <div className="d-flex align-items-center">
                <div className="flex-grow-1 overflow-hidden">
                  <p className="text-uppercase fw-medium text-muted text-truncate mb-0">{t(item.label)}</p>
                </div>
              </div>
              <h4 className="fs-22 fw-semibold ff-secondary mb-0 mt-3">
                {typeof item.value === 'number' ? item.value.toLocaleString() : item.value}
              </h4>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default TableSummary;